<template>
  <div
    class="d-flex flex-column px-6 py-4 thumbnails__container hide-scrollbar"
  >
    <div
      v-for="(image, index) in images"
      class="thumbnails__image-container cursor-pointer flex-shrink-0 mb-3"
      :class="{
        'thumbnails__image-container--selected': index === selectedImageIndex,
      }"
      :key="getImageKey(image, index)"
      @click="$emit('selected', index)"
    >
      <ImageMedia
        class="thumbnails__image"
        :size="IMAGE_SIZES.CARD"
        :defaultImage="image"
        :src="image"
      />
    </div>

    <div
      v-if="canAdd"
      class="thumbnails__add-image-button__container flex-shrink-0"
    >
      <ImageSelectWrapper
        :allowMultipleSelect="allowMultipleSelect"
        @selected="$emit('added', $event)"
      >
        <template slot-scope="{ selectFile, isDraggingFile }">
          <v-btn
            class="flex-column thumbnails__add-image-button__button"
            :class="{
              'thumbnails__add-image-button__button--dragging': isDraggingFile,
            }"
            :color="isDraggingFile ? 'primary' : 'blue-grey'"
            elevation="0"
            outlined
            @click="selectFile"
          >
            <div class="d-flex flex-column">
              <v-icon :color="isDraggingFile ? 'primary' : 'blue-grey'" large>
                mdi-image-plus
              </v-icon>

              <p
                class="mb-0 mt-1 text-subtitle-2 blue-grey--text"
                style="white-space: normal;"
              >
                {{ $t('media.drop_images_message') }}
              </p>
            </div>
          </v-btn>
        </template>
      </ImageSelectWrapper>
    </div>
  </div>
</template>

<script>
import { IMAGE_SIZES } from 'rever-media-sdk'

import ImageMedia from '@/components/ImageMedia/ImageMedia.vue'
import ImageSelectWrapper from '@/components/utils/MediaManagementWrapper/ImageSelectWrapper.vue'

export default {
  name: 'GalleryThumbnails',
  components: {
    ImageMedia,
    ImageSelectWrapper,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },

    selectedImageIndex: {
      type: Number,
      default: null,
    },

    readOnly: Boolean,

    canAdd: Boolean,

    allowMultipleSelect: Boolean,
  },

  data() {
    return {
      IMAGE_SIZES,
    }
  },

  methods: {
    getImageKey(image, index) {
      const isMediaObject = Boolean(image.id)
      if (isMediaObject) return image.id

      const base64LastChars = image.slice(-10)
      return `${base64LastChars}-${index}`
    },
  },
}
</script>

<style lang="scss" scoped>
.thumbnails {
  &__container {
    width: 230px;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  &__image-container {
    height: 112px;
    border-radius: 12px;
    overflow: hidden;

    &--selected {
      border: 4px solid $color-blue;
      box-sizing: border-box;
    }
  }

  &__image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &__add-image-button__container {
    height: 112px !important;
  }

  &__add-image-button__button {
    height: 100% !important;
    width: 100%;
    border-radius: 8px;
    border-style: dashed;
    border-width: 2px;

    &--dragging {
      background-color: var(--v-blue-lighten5);
    }
  }
}
</style>
